import { useState, useRef } from 'react';

export const useAttachments = () => {
	const [attachments, setAttachments] = useState([]);
	const fileInputRef = useRef(null);

	const openFilePicker = () => fileInputRef.current?.click();

	const onFilesSelected = (filesList) => {
		const arr = Array.from(filesList || []);
		const mapped = arr.map((f) => {
			const url = URL.createObjectURL(f);
			const isImage = /^image\//.test(f.type);
			return { file: f, url, name: f.name, size: f.size, type: f.type, isImage };
		});
		setAttachments((prev) => [...prev, ...mapped]);
	};

	const removeAttachment = (idx) => {
		setAttachments((prev) => {
			const copy = [...prev];
			const [removed] = copy.splice(idx, 1);
			if (removed?.url) URL.revokeObjectURL(removed.url);
			return copy;
		});
	};

	const clearAttachments = () => {
		attachments.forEach(a => a.url && URL.revokeObjectURL(a.url));
		setAttachments([]);
	};

	return {
		attachments,
		setAttachments,
		fileInputRef,
		openFilePicker,
		onFilesSelected,
		removeAttachment,
		clearAttachments
	};
};